import { useState, useEffect } from 'react';
import { useAtom } from 'jotai';
import { Typography, Button, Box } from '@mui/material';
import {
  RegisterModal,
  UnregisterModal,
  InstrumentListTable,
} from './components';
import { instrumentListVersionAtom } from '../../atoms/instrumentAtoms';
import { accountInfoVersionAtom } from '../../atoms/accountInfoAtoms';

const RegisterButton = (props: any) => {
  return (
    <Button
      sx={{ width: '200px', height: '50px' }}
      size='large'
      variant='contained'
      color='primary'
      onClick={props.onClick}
    >
      器械登録
    </Button>
  );
};

const MainPage = () => {
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(true);

  const [isUnregisterModalOpen, setIsUnregisterModalOpen] = useState(false);
  const [deleteSerial, setDeleteSerial] = useState('');

  const [instrumentListVersion, setInstrumentListVersion] = useAtom(
    instrumentListVersionAtom
  );
  const [accountInfoVersion, setAccountInfoVersion] = useAtom(
    accountInfoVersionAtom
  );

  useEffect(() => {
    setInstrumentListVersion(instrumentListVersion + 1);
    setAccountInfoVersion(accountInfoVersion + 1);
  }, []);

  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='flex-start'
      marginTop='80px'
      flexDirection={'column'}
    >
      <Box
        width='80%'
        justifyContent={'center'}
        alignContent={'center'}
        paddingTop='5%'
      >
        <Box width='100%' display='flex' marginBottom={2}>
          <Typography variant='h4' sx={{ flexGrow: 1 }}>
            登録済の器械一覧
          </Typography>
          <RegisterButton
            onClick={() => {
              setIsRegisterModalOpen(true);
            }}
          />
        </Box>
        <Box width='100%'>
          <Box display={'flex'}></Box>
          <InstrumentListTable
            setDeleteSerial={setDeleteSerial}
            setIsUnregisterModalOpen={setIsUnregisterModalOpen}
          />
        </Box>
      </Box>

      <RegisterModal
        isRegisterModalOpen={isRegisterModalOpen}
        setIsRegisterModalOpen={setIsRegisterModalOpen}
      />
      <UnregisterModal
        deleteSerial={deleteSerial}
        isUnregisterModalOpen={isUnregisterModalOpen}
        setIsUnregisterModalOpen={setIsUnregisterModalOpen}
      />
    </Box>
  );
};

export default MainPage;
